import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Button, DialogContainer, TextField } from 'react-md';
import { NotificationManager } from 'react-notifications';
import { browserHistory } from 'react-router';
import ApiRequestService from '../component/ApiRequestService';
import Error from '../component/ErrorDispaly.js';
import LoadingSpinner from '../component/LoadingSpinner';
import Properties from '../component/Properties';
import SecureShow from '../component/SecureShow';
import TableRow from '../component/TableRow';
import '../css/mediaCss.css';
import styles from '../css/styles.css.js';
import { AppSetting, AppProperties } from '../common/function';

let course = {
  course_name: '',
  course_id: '',
  is_lti_enabled:""
};
export default class Courses extends Component {
  AppSetting = AppSetting();
  appProperties = AppProperties();

  constructor(props) {
    super(props);
    this.state = {
      courses: [],
      temp_course: course,
      temp_id: '',
      visible: false,
      addMode: true,
      errorMessage: '',
      errorType: '',
      loading:true
    };

    this.deleteCourse = this.deleteCourse.bind(this);
    this.addCourse = this.addCourse.bind(this);
    this.changeCourseName = this.changeCourseName.bind(this);
    this.updateCourse = this.updateCourse.bind(this);
    this.isEnterPressed = this.isEnterPressed.bind(this); 
    this.ltiEnable = this.ltiEnable.bind(this);
  }

  componentWillMount() {
    this.setState({
      loading:true
    });
    ApiRequestService({
      method: 'post',
      url: '/getAllCourses'
    }).then(res => {
      this.setState({
        loading:false
      });
      if (res.data.message !== null && res.data.message !== '') {
        NotificationManager.error(res.data.message, 'ERROR', 3000);
      } else if (res.data === '') {
        NotificationManager.error('Connection Problem', 'ERROR', 3000);
      }

      console.debug('course response ', res);
      
      if (res.data && res.data.data && res.data.data.course_names != null) {
        this.setState({
          courses: res.data.data.course_names
        });
     }
    });
  }
  
  addBreadCrumbs = () => {
    this.props.replaceBreadCrumb([
      { name: (this.appProperties.schoolMode?'All Standards':'All Courses'), type: '', onclickPath: '/courses' }
    ]);
  };

  ltiEnable(courseType,id) {
    const payload = {
      course_id: courseType.course_id,
      is_lti_enabled: !courseType.is_lti_enabled
    };


    this.setState({
      loading:true
    });
    ApiRequestService({
      method: 'post',
      url: '/enableLTICourse',
      data: payload
    }).then(res => {
      this.setState({
        loading:false
      });
      console.debug(res);
      if (res.data.message !== null && res.data.message !== '') {
        NotificationManager.error(res.data.message, 'ERROR', 3000);
      }else{
      //window.localtion.reload();
      if (res.data.data != null) {
        //this.state.courses[this.state.temp_id] = payload
        let tempCourse = this.state.courses;
        tempCourse[id].is_lti_enabled = !tempCourse[id].is_lti_enabled
        tempCourse[id].status = 1;
        this.setState({
          courses: tempCourse
        });
      }
      }
    });
  }

  handleUpdateCourseStatus = (course, id) => {
    const payload = {
      course_id: course.course_id,
      status: course.status === 0 ? 1 : 0
    };
    console.debug("payload>>>>>", payload)

    this.setState({
      loading:true
    });

    const response = ApiRequestService({
      method: 'POST',
      url: '/updateCourseStatus',
      data: payload
    })

    response.then(res => {
      console.debug("res", res)
      if (res.data.message !== null && res.data.message !== '') {
        NotificationManager.error(res.data.message, 'ERROR', 3000);
      }else{
      if (res.data.data != null) {
        let tempCourse = this.state.courses;
        tempCourse[id].status = payload.status;
        console.debug(" tempCourse[id]",  tempCourse[id])
        this.setState({
          courses: tempCourse
        });
      }
      }
    }).finally(() => {
      this.setState({
        loading: false
      });
    })

  }

  componentWillUpdate() {
    this.addBreadCrumbs();
  }
  componentWillUnmount() {
    this.removeBreadCrumbs();
  }




  removeBreadCrumbs = () => {
      this.props.replaceBreadCrumb([
      ]);     
    

  };


  addCourse() {
    console.debug('Add course :' + this.state.temp_course.course_name);
    const payload = {
      course_name: this.state.temp_course.course_name
    };
    this.setState({
      loading:true
    });
    ApiRequestService({
      method: 'post',
      url: '/addCourse',
      data: payload
    }).then(res => {
      this.setState({
        loading:false
      });
      console.debug('Add course response : ', res);
      console.debug('Add course response : ', res.data.message);
      var tempCourse = this.state.courses;
      if (res.data.message !== null && res.data.message !== '') {
        NotificationManager.error(res.data.message, 'ERROR', 3000);
      }
      if (res.data.data != null) {
        tempCourse.push({
          course_name: res.data.data.course_name,
          course_id: res.data.data.course_id,
          status: res.data.data.status,
          is_lti_enabled: res.data.data.is_lti_enabled,
        });
        this.setState({
          courses: tempCourse,
          loading:false
        });
      }
      this.hide();
    });
  }

  editCourse(id) {
    this.setState({
      temp_course: this.state.courses[id],
      temp_id: id,
      addMode: false
    });
    this.show(false);
  }

  updateCourse() {
    console.debug('Editing course :' + this.state.temp_course.course_id);

    const payload = this.state.temp_course;
    this.setState({
      loading:true
    });
    ApiRequestService({
      method: 'post',
      url: '/updateCourse',
      data: payload
    }).then(res => {
      this.setState({
        loading:false
      });
      console.debug(res);
      if (res.data.message !== null && res.data.message !== '') {
        NotificationManager.error(res.data.message, 'ERROR', 3000);
      }
      if (res.data.data != null) {
        //this.state.courses[this.state.temp_id] = payload
        console.debug('UpdateCourse State: ', this.state.courses);
        this.setState({
          courses: this.state.courses,
          temp_course: course
        });
      }
      this.hide();
    });
  }
  deleteCourse(id) {
    console.debug(
      'Deleting course i:' + id + ' id: ' + this.state.courses[id].course_id
    );
    const payload = {
      course_id: this.state.courses[id].course_id
    };
    this.setState({
      loading:true
    });
    ApiRequestService({
      method: 'post',
      url: '/deleteCourse',
      data: payload
    }).then(res => {
      this.setState({
        loading:false
      });
      console.debug(res);
      if (res.data.message !== null && res.data.message !== '') {
        NotificationManager.error(res.data.message, 'ERROR', 3000);
      }else{
      //window.localtion.reload();
        this.state.courses.splice(id, 1);
        console.debug('Spliced Array', this.state.courses);
        this.setState({
          courses: this.state.courses
        });
      }
    });
  }
  changeCourseName(event) {
    let curCourseName = this.state.temp_course;
    curCourseName.course_name = event;
    this.setState({
      temp_course: curCourseName
    });
  }

  show = isCourseEnable => {
    if (isCourseEnable) {
      this.setState({
        temp_course: {
          course_name: '',
          course_id: ''
        }
      });
    }
    this.setState({ visible: true });
  };

  hide = () => {
    this.setState({
      visible: false,
      addMode: true
    });
  };
  subjPage() {
    browserHistory.push( this.appProperties.baseFolder + 'courses');
  }
  delete = id => {
    confirmAlert({
      title: 'Are you sure want to delete this course?',
      message: 'Press Confirm to submit',

      confirmLabel: 'Cancel',
      cancelLabel: 'Confirm',
      onCancel: () => this.deleteCourse(id)
      //   onCancel: () => ,
    });
  };

  isEnterPressed(event){
    var code = event.keyCode || event.which;
    if(code === 13) { //13 is the enter keycode
      if (this.state.addMode) {
      this.addCourse();
    } else{
      this.updateCourse();
    }
  }
  }

  render() {
    let button = null;
    if (this.state.addMode) {
      button = (
        <Button style={styles.addButton} autoFocus onClick={this.addCourse}>
          {this.appProperties.schoolMode?"Add Standard":"Add Course"}
        </Button>
      );
    } else {
      button = (
        <Button style={styles.addButton} autoFocus onClick={this.updateCourse}>
         {this.appProperties.schoolMode?"Update Standard":"Update Course"}
        </Button>
      );
    }
    var cancelButton = (
      <Button style={styles.cancelButton} onClick={this.hide}>
        Cancel
      </Button>
    );

    const actions = [];
    actions.push(button);
    actions.push(cancelButton);

    return (
      (this.state.loading)?
         <LoadingSpinner loading={this.state.loading} />
      :
      <SecureShow targetRole={1}>
        <div>
         
          <div style={styles.courseTitle} className="courseContainerDiv">
          {this.appProperties.schoolMode
          ? "Standards"
        : "Courses"
        }
            
            {(parseInt(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`), 10)) >= 2 ? (
            <div style={styles.floatRight}>
            <Button style={styles.courseAddButton} className="archive-button" primary raised
                onClick={() => this.show(true)}>
                  Add a New Course
              </Button>
            </div>
          ) : (
                ''
        )}
          </div>
          {
            <DialogContainer
              id="simple-action-dialog"
              width="500px"
              visible={this.state.visible}
              onHide={this.hide}
              actions={actions}
              title={this.appProperties.schoolMode?"New Standard":"New Course"}
            >
{/*               <input
                type="text"
                name="course_name"
                defaultValue={this.state.temp_course.course_name}
                onChange={this.changeCourseName}
                onKeyPress={this.isEnterPressed.bind(this)}
              /> */}
              <TextField 
                 name="course_name"
                 value={this.state.temp_course.course_name}
                 onChange={this.changeCourseName}
                 onKeyPress={this.isEnterPressed.bind(this)}
                 className="md-cell md-cell--12"
                />
            </DialogContainer>
          }
          <table style={styles.courseTable} className="courseTable">
            <thead style={styles.thead}>
              <tr>
                <th>ID</th>
                {this.appProperties.schoolMode
                  ?
                    <th>Standard</th>
                  :
                    <th>Courses</th>
                }
                <th>LTI Course</th>
                <th>Publish/Unpublish</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {this.state.courses != null
                ? this.state.courses.map((course, i) => (
                    <TableRow
                      key={i}
                      data={course}
                      id={course.course_id}
                      name={course.course_name}
                      title={this.appProperties.schoolMode?'Standards':'Courses'}
                      type={''}
                      url={
                        'sections?course_id=' +
                        course.course_id +
                        '&course_name=' +
                        course.course_name +
                        '&is_lti_enabled=' +
                        course.is_lti_enabled
                      }
                      onLTICourseChange={() => this.ltiEnable(course,i)}
                      handleUpdateCourseStatus={() => this.handleUpdateCourseStatus(course, i)}
                      onEditClick={() => this.editCourse(i)}
                      pushId={'course'}
                      onDeleteClick={() => this.delete(i)}
                      instructorSubject = {true}
                      isLtiCourse={course.is_lti_enabled}
                      status={course.status}
                    />
                  ))
                : ''}
            </tbody>
          </table>

          <Error
            type={this.state.errorType}
            message={this.state.errorMessage}
          />
        </div>
      </SecureShow>
    );
  }
}
